/* Collection products use the active Shopify origin in a theme preview or store. */
(() => {
  const section = document.getElementById('featured');
  if (!section || section.dataset.collectionsReady) return;
  section.dataset.collectionsReady = 'true';
  const tabs = [...section.querySelectorAll('.collection-tab')];
  const loads = new Map();
  const native = section.dataset.nativeProducts === 'true';
  const store = native ? location.origin : 'https://wvckwrld.store';
  const handles = {scum:'scum',clothing:'tees',journals:'journals'};
  const panels = new Map(tabs.map(tab => [tab.dataset.category, document.getElementById(tab.getAttribute('aria-controls'))]));
  const safeUrl = (value, base) => { try { const url=new URL(value,base);return /^https?:$/.test(url.protocol)?url:null; } catch { return null; } };
  for (const tab of tabs) {
    const panel=panels.get(tab.dataset.category);
    const path=panel?.dataset.collectionUrl || (native ? new URL(tab.getAttribute('href'),location.href).pathname : '/collections/'+handles[tab.dataset.category]);
    const url=safeUrl(path,store);
    if (url) { tab.href=url.href;panel.dataset.collectionUrl=url.href; }
  }
  function render(grid, products, collectionUrl) {
    const fragment=document.createDocumentFragment();
    for (const product of products) {
      const productUrl=safeUrl('/products/'+encodeURIComponent(product.handle),store);
      if(!product.handle||!productUrl)continue;
      const li=document.createElement('li');li.className='product-card';
      const link=document.createElement('a');link.href=productUrl.href;
      const frame=document.createElement('div');frame.className='frame';
      const src=product.images?.[0]?.src || product.image?.src;
      const imageUrl=src&&safeUrl(src,store);
      if(imageUrl){const image=document.createElement('img');image.src=imageUrl.href;image.alt=product.title||'';image.loading='lazy';image.decoding='async';frame.append(image);}
      const name=document.createElement('div');name.className='name';name.textContent=product.title||'';
      link.append(frame,name);li.append(link);fragment.append(li);
    }
    if(fragment.childNodes.length)grid.replaceChildren(fragment);
    else {const empty=document.createElement('li');empty.className='featured-empty';empty.textContent='No pieces available in this collection yet.';grid.replaceChildren(empty);}
    let all=grid.parentElement.querySelector('.collection-view-all');
    if(!all){all=document.createElement('a');all.className='collection-view-all';grid.parentElement.append(all)}
    all.href=collectionUrl;all.textContent='VIEW COLLECTION';
  }
  async function requestProducts(collectionUrl, signal) {
    const url=new URL(collectionUrl.href);url.pathname=url.pathname.replace(/\/$/,'')+'/products.json';url.search='';url.searchParams.set('limit','250');
    const response=await fetch(url.href,{signal,credentials:native?'same-origin':'omit',cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok||!(response.headers.get('content-type')||'').includes('json'))throw new Error('Product feed unavailable');
    const data=await response.json();if(!Array.isArray(data.products))throw new Error('Product feed invalid');
    return data.products;
  }
  async function discoverJournals(signal, currentUrl) {
    const indexUrl=new URL('/collections.json?limit=250',store);
    const response=await fetch(indexUrl.href,{signal,credentials:native?'same-origin':'omit',cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Collection list unavailable');
    const data=await response.json();
    if(!Array.isArray(data.collections))throw new Error('Collection list invalid');
    const normalize=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    const exact=data.collections.filter(c=>['journal','journals'].includes(normalize(c.title))||['journal','journals'].includes(normalize(c.handle)));
    const related=data.collections.filter(c=>/\bjournals?\b/.test(normalize(c.title)));
    const candidates=[...new Map([...exact,...(related.length===1?related:[])].map(c=>[c.handle,c])).values()];
    for(const collection of candidates){
      const url=safeUrl('/collections/'+encodeURIComponent(collection.handle),store);
      if(!url||url.pathname===currentUrl.pathname)continue;
      try{const products=await requestProducts(url,signal);if(products.length)return {url,products};}catch(error){if(signal.aborted)throw error;}
    }
    return null;
  }
  async function load(key) {
    if(loads.has(key))return loads.get(key);
    const panel=panels.get(key),grid=panel?.querySelector('.product-grid');
    if(!grid)return;
    const collectionUrl=safeUrl(panel.dataset.collectionUrl,store);if(!collectionUrl)return;
    const hasRenderedProducts=!!grid.querySelector('.product-card');
    grid.setAttribute('aria-busy','true');
    if(!hasRenderedProducts){const loading=document.createElement('li');loading.className='featured-empty';loading.textContent='Loading pieces…';grid.replaceChildren(loading);}
    const job=(async()=>{
      const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),12000);
      try{
        let products,feedError;
        try{products=await requestProducts(collectionUrl,controller.signal);}catch(error){feedError=error;}
        if(key==='journals'&&(!products||!products.length)&&!hasRenderedProducts){
          // Collection titles and URL handles can differ in Shopify.
          const discoveryController=new AbortController();
          const discoveryTimeout=setTimeout(()=>discoveryController.abort(),12000);
          try{
            const found=await discoverJournals(discoveryController.signal,collectionUrl);
            if(found){products=found.products;feedError=null;collectionUrl.href=found.url.href;panel.dataset.collectionUrl=found.url.href;tabs.find(t=>t.dataset.category===key).href=found.url.href;}
          }catch(error){/* Keep the original request outcome if discovery is unavailable. */}
          finally{clearTimeout(discoveryTimeout);}
        }
        if(!products)throw feedError||new Error('Product feed unavailable');
        // Never erase products Shopify already rendered with an empty feed response.
        if(products.length||!hasRenderedProducts)render(grid,products,collectionUrl.href);
      }catch(error){
        loads.delete(key);
        if(!hasRenderedProducts){
          const li=document.createElement('li');li.className='featured-empty';li.append('Products couldn’t load. ');
          const retry=document.createElement('button');retry.type='button';retry.className='collection-retry';retry.textContent='Retry';retry.addEventListener('click',()=>load(key));
          const link=document.createElement('a');link.href=collectionUrl.href;link.textContent='View collection';li.append(retry,' · ',link);grid.replaceChildren(li);
        }
      }finally{clearTimeout(timeout);grid.removeAttribute('aria-busy');}
    })();
    loads.set(key,job);return job;
  }
  function select(tab){
    for(const item of tabs){const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;panels.get(item.dataset.category).hidden=!active;}
    load(tab.dataset.category);
  }
  for(const tab of tabs){
    tab.addEventListener('click',event=>{if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();select(tab)});
    tab.addEventListener('keydown',event=>{let index=tabs.indexOf(tab);if(event.key==='ArrowRight')index=(index+1)%tabs.length;else if(event.key==='ArrowLeft')index=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;event.preventDefault();select(tabs[index]);tabs[index].focus({preventScroll:true})});
  }
  if(tabs.length)load(tabs.find(tab=>tab.getAttribute('aria-selected')==='true')?.dataset.category||tabs[0].dataset.category);
})();
